/* Service enquiry signals use Shopify's existing, consent-gated analytics API. */
(() => {
  'use strict';

  if (document.documentElement.dataset.serviceJourneyInitialized === 'true') return;
  document.documentElement.dataset.serviceJourneyInitialized = 'true';

  const services = new Set(['unsure', 'fleets', 'business', 'residential', 'managed', 'events']);
  const published = new Set();
  let consentFeatureRequested = false;
  const pages = new Map([
    ['/', 'home'],
    ['/pages/services', 'services'],
    ['/pages/contact', 'contact'],
    ['/pages/fleets-commercial-vehicles', 'fleets'],
    ['/pages/homes-home-offices', 'homes'],
    ['/pages/managed-services', 'managed'],
    ['/pages/pop-up-surge-connectivity', 'events'],
    ['/pages/about', 'about'],
    ['/pages/learn', 'learn'],
    ['/pages/faq', 'faq']
  ]);
  const pageServices = new Map([
    ['fleets', 'fleets'],
    ['homes', 'residential'],
    ['managed', 'managed'],
    ['events', 'events']
  ]);

  function pageKind() {
    return pages.get(window.location.pathname.replace(/\/$/, '') || '/') || 'other';
  }

  function queryService(url) {
    const values = url.searchParams.getAll('service');
    return values.length === 1 && services.has(values[0]) ? values[0] : null;
  }

  function currentService(enquiry) {
    const selected = enquiry?.querySelector('[data-project-service]')?.selectedOptions?.[0]?.dataset.service;
    if (services.has(selected)) return selected;
    return queryService(new URL(window.location.href)) || pageServices.get(pageKind()) || 'unsure';
  }

  function publishOnce(name, service) {
    if (published.has(name)) return;
    try {
      const shopify = window.Shopify;
      if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function' ||
          shopify.customerPrivacy.analyticsProcessingAllowed() !== true ||
          typeof shopify?.analytics?.publish !== 'function') return;

      // Mark before calling: a rejected promise must not produce a duplicate retry.
      published.add(name);
      const result = shopify.analytics.publish(name, {
        service: services.has(service) ? service : 'unsure',
        page: pageKind()
      });
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_) {
      // Analytics support or failures must never interrupt a native form or link.
    }
  }

  function confirmPostedEnquiry() {
    try {
      const navigation = window.performance?.getEntriesByType?.('navigation')?.[0];
      if (navigation?.type === 'reload' || navigation?.type === 'back_forward') return;
      const enquiry = document.querySelector('[data-project-enquiry][data-form-state="posted"]');
      if (enquiry) publishOnce('underscore_enquiry_submission_confirmed', currentService(enquiry));
    } catch (_) {
      // Leave Shopify's posted-success and error UI untouched.
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    try {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== '/pages/contact' || url.hash !== '#project-form') return;
      publishOnce('underscore_consultation_cta_clicked', queryService(url) || currentService());
    } catch (_) {
      // A malformed link or unavailable analytics must retain its native behaviour.
    }
  });

  function startEnquiry(event) {
    const enquiry = event.target.closest?.('[data-project-enquiry]');
    if (enquiry) publishOnce('underscore_enquiry_started', currentService(enquiry));
  }
  document.addEventListener('input', startEnquiry);
  document.addEventListener('change', startEnquiry);
  document.addEventListener('submit', (event) => {
    const enquiry = event.target.querySelector?.('[data-project-enquiry]');
    if (enquiry) publishOnce('underscore_enquiry_submission_attempted', currentService(enquiry));
  }, true);

  function initializeAnalytics() {
    try {
      const shopify = window.Shopify;
      if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function' &&
          typeof shopify?.loadFeatures === 'function' && !consentFeatureRequested) {
        consentFeatureRequested = true;
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) confirmPostedEnquiry();
        });
      }
    } catch (_) {
      // Use Shopify's supported loader without changing any consent decision.
    }
    confirmPostedEnquiry();
  }

  initializeAnalytics();
  document.addEventListener('DOMContentLoaded', initializeAnalytics, { once: true });
  window.addEventListener('load', initializeAnalytics, { once: true });
  document.addEventListener('visitorConsentCollected', confirmPostedEnquiry);
  document.addEventListener('shopify:section:load', initializeAnalytics);
})();
